export function CamelToKebabCase(stringToConvert: string): string {
    return stringToConvert.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function isUrl(url: string): boolean {
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
}